<template>
  <v-row>
    <v-col cols="12">
      <input-radio
        v-model="selectUsers"
        :options="options"
        label="Enviar para:"
        v-bind="$attrs"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'NotificationRadioFilter',
  data: (vm) => ({
    options: [
      {
        label: 'Filtrados',
        value: 'filtered',
        color: 'warning',
        action: vm.setFilterUsers,
      },
      {
        label: 'Selecionados',
        value: 'selected',
        color: 'primary',
        action: vm.setUserList,
      },
    ],
    selectUsers: '',
  }),
  computed: {
    handleFilter() {
      return (filters) => this.handleUsersFilter(filters);
    },
    handleList() {
      return (userListId) => this.handleUsersList(userListId);
    },
    filters() {
      return this.notification.notificationFilters;
    },
    userListId() {
      return this.notification.notificationList;
    },
    getOption() {
      return this.options.find(
        (o) => o.value === this.selectUsers,
      );
    },
  },
  methods: {
    setFilter() {
      const option = this.getOption || { action: (v) => v };
      option.action();
    },
    setAllUsersFilter() {
      this.handleList([]);
      this.handleFilter({
        isActive: true,
      });
    },
    setFilterUsers() {
      this.handleList([]);
      this.handleFilter(
        this.filters,
      );
    },
    setUserList() {
      this.handleFilter({});
      this.handleList(
        this.userListId,
      );
    },
  },
  inject: {
    handleUsersFilter: {
      default() {
        return (v) => v;
      },
    },
    handleUsersList: {
      default() {
        return (v) => v;
      },
    },
    notification: {
      default() {
        return {
          notificationFilters: {},
          notificationList: [],
        };
      },
    },
  },
};
</script>
